import { NavigationGuardNext, Route } from 'vue-router'
import { URLS } from '@/router/routes/urlRoutes'
import { actionsRoutes } from '@/router/routes/desktop/actionsRoutes'
import { alertsMessagesRoutes } from '@/router/routes/desktop/alertsMessagesRoutes'
import { billlingRoutes } from '@/router/routes/desktop/billingRoutes'
import { configurationPanelRoutes } from '@/router/routes/desktop/configurationPanelRoutes'
import { contactsRoutes } from '@/router/routes/desktop/contactsRoutes'
import { exampleRoutes } from '@/router/routes/exampleRoutes'
import { expedientsRoutes } from '@/router/routes/desktop/expedientsRoutes'
import { externalApplicationsRoutes } from '@/router/routes/desktop/externalApplicationsRoutes'
import { footerRoutes } from '@/router/routes/desktop/footerRoutes'
import { lexboxRedirectViews } from '@/router/routes/desktop/lexboxRedirectRoutes'
import { reportsRoutes } from '@/router/routes/desktop/reportsRoutes'
import { repositoryRoutes } from '@/router/routes/desktop/respositoryRoutes'
import AuditsView from '@/views/Audits/AuditsView.vue'
import DashboardView from '@/views/Dashboard/DashboardView.vue'
import LexnetView from '@/views/Lexnet/LexnetView.vue'
import SearchView from '@/views/Search/SearchView.vue'
import SearchIAView from '@/modules/documentSearcher/views/SearchIAView.vue'
import TabsView from '@/views/Tabs/TabsView.vue'
import OnlineView from '@/views/Online/OnlineView.vue'
import { UserType } from '@/store/modules/auth/authTypes'

export const desktopRoutes = [
  ...actionsRoutes,
  ...alertsMessagesRoutes,
  ...billlingRoutes,
  ...configurationPanelRoutes,
  ...contactsRoutes,
  ...exampleRoutes,
  ...expedientsRoutes,
  ...externalApplicationsRoutes,
  ...footerRoutes,
  ...lexboxRedirectViews,
  ...reportsRoutes,
  ...repositoryRoutes,
  {
    path: `/${URLS.DASHBOARD}`,
    name: URLS.DASHBOARD,
    component: DashboardView,
    meta: {
      requiresAuth: true,
      title: URLS.DASHBOARD,
      userType: [UserType.LEXON_FACTURE]
    }
  },
  {
    path: `/${URLS.SEARCH}/:searchTerm/:tabName`,
    name: URLS.SEARCH,
    component: SearchView,
    meta: {
      requiresAuth: true,
      title: URLS.SEARCH,
      userType: [UserType.LEXON_FACTURE]
    },
    props: true
  },
  {
    path: `/${URLS.SEARCH_IA}`,
    name: URLS.SEARCH_IA,
    component: SearchIAView,
    meta: {
      requiresAuth: true,
      title: URLS.SEARCH_IA
    },
    props: true
  },
  {
    path: `/${URLS.LEXNET}`,
    name: URLS.LEXNET,
    component: LexnetView,
    meta: {
      requiresAuth: true,
      title: URLS.LEXNET
    },
    props: true
  },
  {
    path: `/${URLS.AUDITS}`,
    name: URLS.AUDITS,
    component: AuditsView,
    meta: {
      requiresAuth: true,
      title: URLS.AUDITS
    }
  },

  {
    path: '/:selectedMenuEntity/:submenuName/:selectedRegisterId',
    name: URLS.TABS_VIEW,
    props: true,
    component: TabsView,
    meta: {
      requiresAuth: true,
      userType: [UserType.LEXON_FACTURE]
    },
    beforeEnter: (to: Route, _from: Route, next: NavigationGuardNext) => {
      if (to.meta) {
        to.meta.parentUrl = to.params.selectedMenuEntity
      }
      next()
    }
  },
  {
    path: `/${URLS.ONLINE}`,
    name: URLS.ONLINE,
    component: OnlineView,
    meta: {
      requiresAuth: true,
      title: URLS.ONLINE
    }
  }
]
